import { MutableRefObject, useCallback, useEffect, useRef } from "react";
import debounce from "lodash.debounce";
import styled from "styled-components";

// Styled

const StyledScrollToContainer = styled.div`
  position: relative;
`;

const BUMPER_HEIGHT = "40px";
const StyledBumper = styled.div<{
  ref: MutableRefObject<HTMLDivElement> | null;
}>`
  position: absolute;
  height: ${BUMPER_HEIGHT};
  top: -${BUMPER_HEIGHT};
`;

// Styled End

interface IScrollToProps {
  active?: boolean;
  behavior?: ScrollBehavior;
  onScrollEnd?: () => void;
  id: string;
}

const ActiveScrollTo: React.FC<IScrollToProps> = ({
  behavior,
  onScrollEnd,
  ...props
}) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleScrollEnd = useCallback(
    debounce(() => {
      if (onScrollEnd) onScrollEnd();
    }, 100),
    []
  );

  useEffect(() => {
    document.addEventListener("scroll", handleScrollEnd);

    setTimeout(() => {
      if (scrollRef?.current) {
        scrollRef.current.scrollIntoView({ behavior });
      }
    }, 0);

    return () => {
      document.removeEventListener("scroll", handleScrollEnd);
    };
  }, [scrollRef]);

  return (
    <StyledScrollToContainer>
      <StyledBumper ref={scrollRef} />
      {props.children}
    </StyledScrollToContainer>
  );
};
const ScrollTo: React.FC<IScrollToProps> = ({ active, behavior, ...props }) => {
  if (active) {
    return <ActiveScrollTo behavior={behavior} {...props} />;
  }
  return <>{props.children}</>;
};

export default ScrollTo;
